import React, { useState,useEffect } from "react";
import MainCategories from "./MainCategories"; 
import CenterStone from "./CenterStone";
import DesignCrown from "./DesignCrown";
import DesignShank from "./DesignShank";
import MetalType from "./MetalType";
import DesignAesthetic from "./DesignAesthetic";
import CustomRing from "./CustomRing";
import QuotePrice from "./QuotePrice";
import QuickInfo from "./QuickInfo";
import WeddingStyle from "./WeddingStyle";
import WeddingType from "./WeddingType";
import DressStyle from "./DressStyle";
import DressMotif from "./DressMotif";
import PendantStyle from "./PendantStyle";
import EarRingStyle from "./EarRingStyle";
import BraceletStyle from "./BraceletStyle";
import MulitiDesignYourRings from "./MultiCenterStone";
import CenterStoneSingle from "./CenterStoneSingle";
import Login from "./Login";
import { useForms } from "../actions/FormContext";
import Loading from "../shared/Loading";
function Home() {
  
  const [pageLoading, setPageLoading] = useState(true);
  const [pageerror, setPageerror] = useState(true); 
    const [isLoggedIn, setIsLoggedIn] = useState(false); // Initialize state variable for login status
    const [currentStep, setCurrentStep] = useState(1);
    const [stepper1, setStepper1] = useState(1);
    const [stepper2, setStepper2] = useState(1);
    const [stepper3, setStepper3] = useState(1);
    const [stepper4, setStepper4] = useState(1);
    const [pricepop, setPricepop] = useState([]);
    const [currency, setCurrency] = useState("");
    const [traderName, setTraderName] = useState("");
    const [diamondchartimg, setdiamondchartimg] = useState("");
    const { formData,apiurl,bearertoken,updateFormData } = useForms();
    const [videourl, setVideourl] = useState("");
    const nextStep = (step) => {
      if (step === undefined || step === null) {
        setCurrentStep((prev) => prev + 1);
      } else {
        setCurrentStep(step);
      }
    };
    const backStep = (step) => {    
      if (step === undefined || step === null) {
        setCurrentStep((prev) => Math.max(prev - 1, 1));
      } else {
        setCurrentStep(step);
      }
    };
    const handleLogin = () => { 
      setIsLoggedIn(true);
    } 
    
  useEffect(() => { 
    const username = window.sessionStorage.getItem('username');
    const password = window.sessionStorage.getItem('password'); 
    
    // Check login status first
    if (username && password) { 
      setIsLoggedIn(true);
    }
    // alert(bearertoken);
    // Only fetch if bearertoken exists
    if(bearertoken) {
      fetch(`${apiurl}/ring-builder/traderSettings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          Authorization: bearertoken
        },
        body: JSON.stringify({})
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((appsettings) => {
        if (appsettings.traderSettings.ringbuilderaccess === 1) {
          setPageerror(false);
        } else {
          setPageerror(true);
        }
        setPageLoading(false);
        setPricepop(appsettings.traderSettings.price_estimate);
        setCurrency(appsettings.traderSettings.currency_symbol);
        setdiamondchartimg(appsettings.traderSettings.diamond_color_chart);
        setVideourl(appsettings.traderSettings.manufacturingvideo);
        setTraderName(appsettings.traderSettings.cname);
      })
      .catch((error) => {
        console.error("API Error:", error);
        setPageLoading(false);
        setPageerror(true);
      });
    } else {
      // No token, just stop loading
      setPageLoading(false);
    }
  }, []);

    const setFormCategory = () => {  
    
        if (formData?.MainCategories?.category_name === "Engagement Ring") { 
         // alert("Engagement Ring")  
            setStepper1(2);   
            setStepper2(3);   
            setStepper3(4);   
            setStepper4(5);    
        }  else if (formData?.MainCategories?.category_name === "Wedding Band") {    
         // alert("Wedding Band")  
            setStepper1(10);
            setStepper2(11);      
            if(formData?.WeddingCrown?.weddingtype == "Single stone"){     
              setStepper3(18);
            }else if(formData?.WeddingCrown?.weddingtype == "Plain") {  
              setStepper3(5);
            }else{ 
              setStepper3(17);
            }       
            setStepper4(5);
            //setBackVal5(6)
          } else if (formData?.MainCategories?.category_name === "Pendant") {       
            setStepper1(14); 
            if(formData?.PendentStyle?.pendenttype == "Solitaire" || formData?.PendentStyle?.pendenttype == "Solitaire + halo" || formData?.PendentStyle?.pendenttype == "3 stone"){
              setStepper2(2); 
               }else{  
                setStepper2(18); 
               }     
            setStepper3(5);
            setStepper4(6);
            //setBackVal5(6)
          } else if (formData?.MainCategories?.category_name === "Dress Ring") {
           // alert("Dress Ring")        
            setStepper1(12);
            if(formData?.DressStyle?.styletype== "Solitaire" || formData?.DressStyle?.styletype =="Solitaire + halo" || formData?.DressStyle?.styletype== "3 stone"){ 
            setStepper2(2);
            }else{ 
            setStepper2(17);
            }     
            setStepper3(5); 
            setStepper4(6);
            
          } else if (formData.MainCategories?.category_name === "Bracelet") {      
            setStepper1(16);
            if(formData.BraceletStyle.bracelettype == "Tennis" || formData.BraceletStyle.bracelettype == "3 stone" ){
              setStepper2(17);
             }else{       
              setStepper2(currentStep);
             } 
            setStepper3(5);
            setStepper4(5);     
          } else if (formData.MainCategories?.category_name === "Earrings") {      
            setStepper1(15); 
            if(formData.EarringsCrown.earringstype == "Ear studs" || formData.EarringsCrown.earringstype =="Ear studs + halo" || formData.EarringsCrown.earringstype== "3 stone"){ 
              setStepper2(2);
             }else{ 
              setStepper2(18);
             } 
            setStepper3(5);
            setStepper4(5); 
          }
          
        
      };
    
      useEffect(() => {  
       
        updateFormData("showPricepover", {
          pricepop: pricepop,
        });
       // alert(formData.showPricepover?.pricepop)
      
      setFormCategory();  
       
 
      }, [currentStep]); 
  
      
  return (
    <>
      {pageLoading ? 
        <Loading></Loading>
        :  
        (
          <>   
            {!pageerror ? ( 
              <> 
                {!isLoggedIn ? (
                  <Login onLogin={handleLogin} />
                ) : (
                  <>
                    {currentStep === 1 && (
                      <MainCategories next={nextStep} next2={() => setCurrentStep(9)} />
                    )}

                    {currentStep === 2 && (
                      <CenterStone
                        next={nextStep}
                        back={backStep}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 3 && (
                      <DesignCrown
                        next={nextStep}
                        back={backStep}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 4 && (
                      <DesignShank
                        next={nextStep}
                        back={backStep}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 5 && (
                      <MetalType
                        next={nextStep}
                        back={backStep}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 6 && (
                      <DesignAesthetic
                        next={nextStep}
                        back={backStep}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 7 && (
                      <CustomRing
                        next={nextStep}
                        back={backStep}
                        videourl={videourl}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 8 && (
                      <QuotePrice
                        next={nextStep}
                        back={backStep}
                        diamondimg={diamondchartimg}
                        tradername={traderName}
                      />
                    )}

                    {currentStep === 9 && (
                      <QuickInfo
                        back={backStep}
                        backtohome={() => setCurrentStep(1)}
                        mycurency={currency}
                        tradername={traderName}
                      />
                    )}

                    {currentStep === 10 && (
                      <WeddingStyle
                        next={nextStep}
                        back={backStep}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 11 && (
                      <WeddingType
                        next={nextStep}
                        back={backStep}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 12 && (
                      <DressStyle
                        next={nextStep}
                        back={backStep}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 13 && (
                      <CustomRing
                        next={nextStep}
                        back={backStep}
                        videourl={videourl}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 14 && (
                      <PendantStyle
                        next={nextStep}
                        back={backStep}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 15 && (
                      <EarRingStyle
                        next={nextStep}
                        back={backStep}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 16 && (
                      <BraceletStyle
                        next={nextStep}
                        back={backStep}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 17 && (
                      <DressMotif
                        next={nextStep}
                        back={backStep}
                        setpperback1={() => setCurrentStep(stepper1)}
                        setpperback2={() => setCurrentStep(stepper2)}
                        setpperback3={() => setCurrentStep(stepper3)}
                        setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}

                    {currentStep === 18 && (
                      <CenterStoneSingle           
                        next={nextStep}
                        back={backStep}
                        setpperback1={() => setCurrentStep(stepper1)} setpperback2={() => setCurrentStep(stepper2)} setpperback3={() => setCurrentStep(stepper3)} setpperback4={() => setCurrentStep(stepper4)}
                      />
                    )}
                  </>
                )}
              </>
            ) : (
              <div style={{ color:"red",fontSize:"25px", display:"flex", height:"100vh",justifyContent:"center"}}>
                <h1>You do not have access to this page.</h1>
              </div>  
            )}
          </>
        )
      }
    </>
  )
}

export default Home
